import { render, staticRenderFns } from "./Pqrs.vue?vue&type=template&id=4d4c6053&scoped=true"
import script from "./Pqrs.vue?vue&type=script&lang=js"
export * from "./Pqrs.vue?vue&type=script&lang=js"
import style0 from "./Pqrs.vue?vue&type=style&index=0&id=4d4c6053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c6053",
  null
  
)

export default component.exports